@if (definition(); as definition) {
  <div id="onboarding-welcome-dialog" class="welcome flex min-h-0 flex-col gap-4 pt-2">
    <div class="welcome-icon mx-auto inline-flex items-center justify-center rounded-full" aria-hidden="true">
      <mat-icon>waving_hand</mat-icon>
    </div>

    <h2 id="onboarding-welcome-title" mat-dialog-title class="welcome-title text-center">{{ definition.welcome.titleKey | translate }}</h2>

    <div mat-dialog-content class="welcome-content min-h-0">
      <!-- o mat-dialog-content força display:block: o espaçamento fica num wrapper próprio -->
      <div class="flex flex-col gap-4">
        <p id="onboarding-welcome-lead" class="welcome-lead text-center">{{ leadKey() | translate }}</p>

        <ul id="onboarding-welcome-benefits" class="benefits flex flex-col gap-2">
          @for (benefitKey of definition.welcome.benefitKeys; track benefitKey) {
            <li class="benefit flex items-start gap-2">
              <mat-icon class="shrink-0" aria-hidden="true">check_circle</mat-icon>
              <span>{{ benefitKey | translate }}</span>
            </li>
          }
        </ul>

        @if (readySteps().length > 0) {
          <div id="onboarding-welcome-ready" class="ready rounded-lg px-3 py-2">
            <p class="ready-title">{{ 'onboarding.welcome.already_ready' | translate }}</p>
            <ul class="ready-list flex flex-wrap gap-2">
              @for (titleKey of readySteps(); track titleKey) {
                <li class="ready-chip inline-flex items-center gap-1 rounded-full px-2 py-0.5">
                  <mat-icon class="shrink-0" aria-hidden="true">done</mat-icon>
                  {{ titleKey | translate }}
                </li>
              }
            </ul>
          </div>
        }
      </div>
    </div>

    <div mat-dialog-actions class="welcome-actions flex shrink-0 flex-col gap-2">
      <button id="onboarding-welcome-start-button" type="button" class="btn-primary w-full justify-center" cdkFocusInitial (click)="close('start')">
        {{ 'onboarding.welcome.start' | translate }}
      </button>
      <button id="onboarding-welcome-later-button" type="button" class="btn-secondary w-full justify-center" (click)="close('later')">
        {{ 'onboarding.welcome.later' | translate }}
      </button>
      <p class="welcome-hint text-center">{{ 'onboarding.welcome.later_hint' | translate }}</p>
    </div>
  </div>
}
